import React, { useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { setState } from "../../../ducks/lightboxSlice"

import ReactPlayer from "react-player"

import * as s from "./Video.module.scss"
import Play from "../../../assets/icons/play.svg"

export const Video = ({
  url,
  className = "",
  hidePlayButton = false,
  cover = false,
  flexibleHeight = true,
}) => {
  const dispatch = useDispatch()
  const isClient = typeof window === "object"
  const _wrapper = useRef(null)
  const _card = useRef(null)

  const [loaded, setLoaded] = useState(false)

  return (
    <div
      className={`${s.Wrapper} ${
        cover && flexibleHeight ? s.Wrapper__cover : ""
      }`}
    >
      <div className={`${s.Card} ${cover ? s.Card__cover : ""}`} ref={_card}>
        {!hidePlayButton && (
          <div
            className={s.Card__playBtn}
            style={{
              opacity: loaded ? 1 : 0,
            }}
            onClick={() =>
              dispatch(
                setState({
                  url: url,
                  visible: true,
                }),
              )
            }
          >
            <div>
              <img src={Play} alt="Play" />
            </div>
          </div>
        )}
        <div className={s.Card__overlay} />
        <div
          className={`${s.Card__Player_Wrapper} ${className}`}
          ref={_wrapper}
          style={{
            opacity: loaded ? 1 : 0,
          }}
        >
          {isClient && (
            <ReactPlayer
              url={url}
              playing={true}
              loop={true}
              controls={false}
              volume={0}
              muted={true}
              playsinline={true}
              width={"100%"}
              height={"100%"}
              style={{
                transform: "scale(1.4)",
              }}
              onReady={() => {
                if (loaded) return
                setLoaded(true)
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
